module.exports = __webpack_public_path__ + "static/assets/kim-yong-profile.972907b.png";